import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Traiing from "../assets/img/training-class.svg";
import Rating from "../assets/img/star-rating.svg";
import boxes from "../assets/img/bxs_group.svg";
import time from "../assets/img/time.svg";
import moment from "moment";
import evalutiona from "../assets/img/evaluation.svg";
import calendar from "../assets/img/calendar.svg";
import Select from "react-select";

import allvideo from "../assets/img/all-img-video.svg";
import imgs from "../assets/img/img-img.svg";
import video from "../assets/img/video.svg";
import play from "../assets/img/play-icon.svg";

import allvideoInactive from "../assets/img/all-img-video-inactive.svg";
import imgsActive from "../assets/img/img-img-active.svg";
import videoActive from "../assets/img/video-active.svg";

import {
  GetFunction,

  SubmitResponse,
  UpdateReponse,

} from "../utils/ApiFunctions";

import { toast } from "react-toastify";
import SelectSchoolModal from "../Component/SelectSchoolModa";
// import CreateGalleryModal from "../Component/CreateGalleryModal";

import { useLocalization } from "../Component/Localization/Localization";
import Loader from "../Component/Loader/Loader";

import { GetValueLableWithId } from "../utils/Helper";
function Dashboard() {
  const { t } = useLocalization();

  const [profileData, setProfileData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [dashboard, setDashboardData] = useState();
  const [schoolmodal, setSchollModal] = useState(false);
  const [creatmodal, setCreateModal] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const [options, setOptions] = useState([]);

  const [broadCast, SetBroadCastList] = useState();
  const [gallerydata, setGallery] = useState([]);
  const [type, setGalleryType] = useState("both");
  const [page, setPage] = useState(1);
  const [schoolList, setSchoolList] = useState([]);
  const usr = localStorage.getItem("user_id");
  const school = localStorage.getItem("school");
  const limit = 10;
  const [schoolId, setSchoolId] = useState(localStorage.getItem("school"));
  useEffect(() => {
    if (!schoolId) {
      setSchollModal(true);
    }
  }, [schoolId]);
  useEffect(() => {
    setSchoolId(localStorage?.getItem("school"));
    setOptions(GetValueLableWithId(schoolList, ["_id", "name"]));
  }, [schoolmodal, schoolList]);

  async function BroadCastList() {
    const data = { page: 1, limit: 2, school: schoolId ? schoolId : "" };
    const response = await SubmitResponse(`newsBroadcast/list`, data);
    if (response.status == 200) {
      SetBroadCastList(response?.data?.data);
    }
  }
  async function GetSchoolList() {
    const res = await GetFunction(`school/get/list?user=${usr}&pages=all`);
    if (res.status == 200) {
      setSchoolList(res?.data?.data?.data);
    }
  }
  useEffect(() => {
    GetSchoolList();
  }, []);
  useEffect(() => {
    setLoader(true);
    async function fetchData() {
      const response = await GetFunction(
        `/home/nurse-home?school=${schoolId ? schoolId : ""}`
      );
      if (response.status == 200) {
        setDashboardData(response?.data?.data);
        setLoader(false);
      }
    }

    fetchData();

    GetSchoolList();
  }, [schoolId]);
  useEffect(() => {
    if (schoolId) {
      BroadCastList();
    }
  }, [schoolId]);
  async function GalleyList() {
    const response = await GetFunction(
      `starGallery/list?type=${type}&page=${page}&limit=${limit}&school=${schoolId}`
    );
    if (response.status == 200) {
      setGallery(response?.data?.data);
      setTotalPages(response?.data?.pagination?.totalPages);
    }
  }
  useEffect(() => {
    if (schoolId) {
      GalleyList();
    }
  }, [type, page, schoolId]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const UpdateReadStatus = async (val) => {
    const res = await UpdateReponse("newsBroadcast/update/" + val?._id, {
      isRead: val?.isRead == false ? 1 : 0,
    });
    if (res.status == 200) {
      toast.success(res?.data?.data?.message);
      BroadCastList();
    }
  };

  const handlePageChange = (val) => {
    setPage(val);
  };
  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={page === i ? "active-btn pagination-li" : "pagination-li"}
        >
          <button onClick={() => handlePageChange(i)}>{i}</button>
        </li>
      );
    }
    return pageNumbers;
  };

  async function GetDetails() {
    const res = await GetFunction("/user/profileDetails");
    if (res.status == 200) {
      setProfileData(res?.data?.data);
    }
  }
  useEffect(() => {
    GetDetails();
  }, []);

  if (loader) {
    return <Loader />;
  }
  const getOrdinalSuffix = (number) => {
    const suffixes = ["st", "nd", "rd"];
    const remainder10 = number % 10;
    const remainder100 = number % 100;

    return remainder10 === 1 && remainder100 !== 11
      ? "st"
      : remainder10 === 2 && remainder100 !== 12
      ? "nd"
      : remainder10 === 3 && remainder100 !== 13
      ? "rd"
      : "th";
  };

  return (
    <div id="main">
      <div className="dashboard_heading">
        <h1>{t("your_dashboard")}</h1>
        {/* <select
          className="form-control mt-1 w-25"
          onChange={(e) => {
            setSchoolId(e.target.value);
            localStorage.setItem("school", e.target.value);
          }}
          value={schoolId}
        >
          <option selected value="" disabled>
            --{t("select_school")}--
          </option>
          {schoolList?.schoolStaff &&
            schoolList?.schoolStaff?.map((val, i) => (
              <option value={val?.school?._id}>{val?.school?.name}</option>
            ))}
        </select> */}
        <Select
          placeholder={t("select_school")}
          options={options}
          onChange={(option) => {
            setSchoolId(option.value);
            localStorage.setItem("school", option.value);
          }}
          value={options.find((option) => option.value === schoolId)}
        />
      </div>

      <section className="statistics bg-light">
        <div className="section-heading mb-4">
          <h2>{t("statistics")}</h2>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-3">
            <div className="statistics-student">
              <h3>
                {" "}
                {dashboard?.allocatedStars > 0 ? dashboard?.allocatedStars : 0}
              </h3>
              <p>{t("allocated_stars")}</p>
            </div>
          </div>

          <div className="col-md-3">
            <div className="statistics-student">
              <h3>
                {" "}
                {dashboard?.allocatedStaffs > 0 ? dashboard?.allocatedStaffs : 0}
              </h3>
              <p>{t("allocated_staff")}</p>
            </div>
          </div>

          <div className="col-md-3">
            <div className="statistics-student">
              <h3>
                {" "}
                {dashboard?.deactivatedStars > 0
                  ? dashboard?.deactivatedStars
                  : 0}
              </h3>
              <p>{t("deactive_stars")}</p>
            </div>
          </div>

          <div className="col-md-3">
            <div className="statistics-student">
              <h3>
                {" "}
                {dashboard?.deactivatedStaffs > 0
                  ? dashboard?.deactivatedStaffs
                  : 0}
              </h3>
              <p>{t("deactive_staff")}</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="statistics-student">
              <h3> {dashboard?.performance > 0 ? dashboard?.performance : 0}</h3>
              <p>{t("performance")}</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="statistics-student">
              <h3>
                {" "}
                {dashboard?.activationRequest > 0
                  ? dashboard?.activationRequest
                  : 0}
              </h3>
              <p>{t("activation_request")}</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="statistics-student">
              <h3> {dashboard?.reports > 0 ? dashboard?.reports : 0}</h3>
              <p>{t("reports")}</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="statistics-student">
              <h3> {dashboard?.todayVisit > 0 ? dashboard?.todayVisit : "0"}</h3>
              <p>{t("today_visits")}</p>
            </div>
          </div>
        </div>
      </section>

      {!schoolId && (
        <SelectSchoolModal
          show={schoolmodal}
          close={() => setSchollModal(false)}
          schoolList={schoolList}
        />
      )}

      {/* <CreateGalleryModal
        show={creatmodal}
        onHide={() => setCreateModal(false)}
        callback={GalleyList}
      /> */}
    </div>
  );
}

export default Dashboard;
